import { helper, http } from "../util";
import { Redirect } from 'react-router-dom';

const controller = "PaymentForms";

//types
export const RESET_STORE = "RESET_STORE";
export const REQUEST_PAYMENTFORM = "REQUEST_PAYMENTFORM";
export const RECEIVE_PAYMENTFORM = "RECEIVE_PAYMENTFORM";

//methods
const _resetStore = () => ({ type: RESET_STORE });
export const resetStore = () => (dispatch) => dispatch(_resetStore());

const requestItem = () => ({ type: REQUEST_PAYMENTFORM });
const receiveItem = (payload) => ({ type: RECEIVE_PAYMENTFORM, payload });
export const submit = data => dispatch => {
    dispatch(requestItem());

    return dispatch(() => http.upload(helper.getApiPath(controller, 'Submit'), data).then(res => {
        console.log(3, res.RedirectUrl);
        dispatch(receiveItem(res));
        window.location.href = res.RedirectUrl;
    }));
}


